import { useCallback, useSyncExternalStore } from 'react';
import { useDocumentStore } from './useDocumentStore';

export default function useDataSourceById(dataSourceId: string) {
  const store = useDocumentStore();

  const getOptions = useCallback(() => store.getDataSourceById(dataSourceId), [dataSourceId, store]);
  const options = useSyncExternalStore(store.addDataChangedListener, getOptions);

  return { options };
}
